module.exports = __webpack_public_path__ + "static/media/kakaoplus.f3b1a647.png";